import { NextRouter } from "next/router";
import { CartItem } from "@/contexts/CartContext";

export const sendToWhatsAPP = (router: NextRouter, title: string, quantity: number, sku: string, price: number, url: string) => {
    const message = `Hi, I like to buy\n\n- Name: ${title}\n- Total Price: LKR ${price.toLocaleString()}\n- Quantity: ${quantity}\n- Code: ${sku}\n- Url: ${url}`;
    window.open(`https://api.whatsapp.com/send?phone=94776411718&text=${encodeURIComponent(message)}`);
};

export const sendCartToWhatsAPP = (router: NextRouter, cartItems: CartItem[]) => {
    if (cartItems.length === 0) return;
    
    let message = "Hi, I would like to order the following items:\n\n";
    
    let totalPrice = 0;
    
    cartItems.forEach((item, index) => {
        const itemTotal = item.variant.price * item.quantity;
        totalPrice += itemTotal;
        
        message += `${index + 1}. ${item.product.title} - ${item.variant.title}\n`;
        message += `   Quantity: ${item.quantity}\n`;
        message += `   Price: LKR ${item.variant.price.toLocaleString()} each\n`;
        message += `   Subtotal: LKR ${itemTotal.toLocaleString()}\n`;
        message += `   Code: ${item.variant.sku}\n\n`;
    });
    
    message += `Total: LKR ${totalPrice.toLocaleString()}\n\n`;
    message += "Please confirm availability and delivery details.";
    
    window.open(`https://api.whatsapp.com/send?phone=94776411718&text=${encodeURIComponent(message)}`);
};
